export function WeakCache<KeyType extends object, ValueType>(
	init: (key: KeyType) => ValueType
): (key: KeyType) => ValueType {
	const map = new WeakMap<KeyType, ValueType>();
	return (key) => {
		if (map.has(key)) return map.get(key)!;
		const value = init(key);
		map.set(key, value);
		return value;
	};
}
